import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const NotFound = lazy(() => import('../../container/pages/404.js'));
const Profile = lazy(() => import('../../container/modules/profile/index.js'));
const Search = lazy(() => import('../../container/modules/search/Search'));
const SearchView = lazy(() => import('../../container/modules/search/SearchView'));
const HQView = lazy(() => import('../../container/modules/search/HQView.js'));
const GroupView = lazy(() => import('../../container/modules/search/GroupView'));
const BatchControlView = lazy(() => import('../../container/modules/search/BatchControlView'));
const ReportGeneration = lazy(() => import('../../container/modules/reports/report'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="profile" element={<Profile />} />
      <Route path="search" element={<Search />} />
      <Route path="search/view" element={<SearchView />} />
      <Route path="search/hq-search/view" element={<HQView />} />
      <Route path="search/group-search/view" element={<GroupView />} />
      <Route path="search/batch-control/view" element={<BatchControlView />} />
      <Route path="report-generation" element={<ReportGeneration />} />
    </Routes>
  );
}

export default PagesRoute;
